<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M10.5,782.53v1.44l-11.08,11.08c-0.31,0.31-0.6,0.4-0.86,0.39c-0.26-0.01-0.52-0.13-0.71-0.33c-0.38-0.39-0.52-1,0.06-1.58
	l11.01-11.01H10.5L10.5,782.53z M-6.65,790.94c0.37,0,0.75,0.04,1.14,0.13l-0.39,0.72c-0.25-0.04-0.49-0.07-0.72-0.07
	c-0.65,0-1.18,0.19-1.54,0.55c-0.58,0.58-0.71,1.58-0.36,2.82c0.02,0.08,0.05,0.17,0.08,0.25l0.93-2.21l0.38,2.83l1.41-1.95
	l0.07,2.48l1.6-0.77c-0.49-0.62-0.83-1.27-1.01-1.9c-0.25-0.86-0.19-1.72,0.37-2.28c0.35-0.35,0.82-0.5,1.33-0.51
	c0.31,0,0.63,0.05,0.95,0.14c0.35,0.1,0.72,0.26,1.08,0.46l-0.58,0.58c-0.25-0.13-0.49-0.22-0.72-0.29
	c-0.26-0.08-0.5-0.11-0.71-0.11c-0.35,0-0.62,0.1-0.8,0.28c-0.29,0.29-0.37,0.81-0.17,1.5s0.69,1.51,1.41,2.24
	c0.72,0.72,1.54,1.21,2.24,1.41c0.7,0.2,1.22,0.12,1.5-0.17c0.29-0.28,0.37-0.81,0.17-1.5c-0.07-0.24-0.17-0.49-0.3-0.74l0.58-0.58
	c0.21,0.37,0.37,0.74,0.48,1.1c0.25,0.86,0.19,1.72-0.37,2.28c-0.56,0.56-1.42,0.62-2.28,0.37c-0.62-0.18-1.27-0.52-1.88-1
	l-0.81,1.69l2.64,0.07l-1.95,1.41l2.83,0.38l-2.12,0.89c0.01,0,0.02,0.01,0.03,0.01c1.24,0.36,2.24,0.22,2.82-0.36
	c0.49-0.49,0.66-1.28,0.49-2.26l0.72-0.39c0.28,1.26,0.12,2.43-0.66,3.21c-0.85,0.85-2.2,0.96-3.6,0.56
	c-1.4-0.41-2.91-1.32-4.26-2.67c-1.34-1.34-2.26-2.85-2.66-4.25c-0.41-1.4-0.3-2.75,0.56-3.6C-8.18,791.19-7.46,790.95-6.65,790.94
	L-6.65,790.94z"/>
</svg>

</template>